import React, { useState, useEffect } from 'react'
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { Link } from 'react-router-dom';
import '../../assets/css/iconplugins.css'
import '../../assets/css/style.css'
import '../../assets/css/responsive.css'
import '../../assets/images/favicon.png'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { formatPhoneNumberIntl } from 'react-phone-number-input'
import {
    CitySelect,
    CountrySelect,
    StateSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { useNavigate } from 'react-router-dom'
import { SendOtp } from "../../api/Auth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify';
import Header from '../../components/common/header/Header';
import CommonImageTransport from '../../components/common/images/CommonImages';
import moment from 'moment-timezone';
// import { isValidPhoneNumber } from "libphonenumber-js";
import Modal from "react-bootstrap/Modal";
import { PhoneValidLenght } from '../../components/common/phonevalidlength/PhoneValidLenght';
import {
    parsePhoneNumberFromString,
    isValidPhoneNumber,
    formatPhoneNumberIntl,
} from "libphonenumber-js";
import { PrivacyPolicy, TermsCondtion } from '../../api/Global';
import { countries } from '../../components/common/countrylist/CountryList';
import ReactHtmlParser from "react-html-parser";

const Recruiter = () => {
    const navigate = useNavigate()
    const [ActiveTabs, setAciveTabs] = useState("Recruiter")
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState()
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [organizationEmail, setOrganizationEmail] = useState('');
    const [country, setCountry] = useState({ capital: "Washington", currency: "USD", currency_name: "United States dollar", currency_symbol: "$", emoji: "🇺🇸", id: 233, iso2: "US", iso3: "USA", latitude: "38.00000000", longitude: "-97.00000000", name: "United States", native: "United States", numeric_code: "840", phone_code: 1, region: "Americas", subregion: "Northern America", tld: ".us" });
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [DOB, setDOB] = useState("");
    const [selectNationlity, setSelectNationlity] = useState("");

    //-----------------------Show/Hide Password-----------------
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState()
    const [countryCode, setCountryCode] = useState()
    const [companyName, setCompanyName] = useState("")
    const [companyDomain, setCompanyDomain] = useState([])
    const [error, setError] = useState('')
    const [isValidEmail, setIsValidEmail] = useState(true)
    const [defaultCountryCode, setDefaultCountryCode] = useState("US")
    const [defaultState, setDefaultState] = useState("")
    const [defaultCity, setDefaultCity] = useState("")
    const [countryid, setCountryid] = useState(country.id);
    const [stateid, setstateid] = useState(0);
    const [cityid, setcityid] = useState(0);
    const [isValidPassword, setIsValidPassword] = useState(true);

    // <-------- Validation for the all parameters ---------->
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [emailError, setEmailError] = useState("");
    const [mobileError, setMobileError] = useState("");

    // <----------- Check the T & C -------------->
    const [isTACChecked, setIsTACChecked] = useState(false);

    // <---------- Show the Popup T&C ------------->
    const [ShowTermsCondition, setShowTermsCondition] = useState(false);

    // <---------- Show the Popup T&C ------------->
    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

    // <------------ P & P ----------------->
    const [PrivacyPolicyList, setPrivacyPolicyList] = useState({});
    const [TermsConditionList, setTermsConditionList] = useState({});

    const DateDataFirst = new Date();
    const timeZone = moment.tz.guess();
    const timeZoneAbbr = moment.tz(DateDataFirst, timeZone).format('z');
    console.log("timeZoneAbbr", timeZoneAbbr)

    // Get today's date
  const today = new Date();

  // Calculate the date 18 years ago
  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() - 18);

  // Convert the max date to ISO format for the input
  const maxDateString = maxDate.toISOString().split("T")[0];

    const handleInputChange = (event, setter, setError) => {
        const value = event.target.value;
        setter(value);
        const regex = /^[a-zA-Z\s]+$/;
        if (!regex.test(value)) {
            setError('Name should contain only alphabetical letters');
        } else {
            setError('');
        }
    };


    const handleChange = (event) => {
        const { value } = event.target;
        setOrganizationEmail(value);
        validateEmail(value);
    };
    
    const validateEmail = (email) => {
        const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/; // Basic email regex
        const forbiddenDomains = ["gmail.com", "yahoo.com", "outlook.com"];
        setEmailError(""); // Clear any previous error
    
        if (!regex.test(email)) {
            setEmailError("Please enter a valid email address.");
            setIsValidEmail(false);
            return;
        }
    
        // Extract the domain from the email
        const domain = email.split("@")[1];
    
        if (forbiddenDomains.includes(domain)) {
            setEmailError(`Emails from ${domain} are not allowed.`);
            setIsValidEmail(false);
            return;
        }
    
        setIsValidEmail(true);
    };
    

    useEffect(() => {
        if (value && validatePhoneNumber(value)) {
            const parsedPhoneNumber = parsePhoneNumberFromString(
                value,
                defaultCountryCode
            );
            if (parsedPhoneNumber) {
                setCountryCode(parsedPhoneNumber.defaultCountryCode);
                setPhoneNumber(`+${parsedPhoneNumber.countryCallingCode}-${parsedPhoneNumber.nationalNumber}`);
                // setPhoneNumber(parsedPhoneNumber.nationalNumber); // Get the national number (without country code)
            }
        }
    }, [value]);

    // Phone Number Validation
    const validatePhoneNumber = (phoneNumber) => {
        const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
        if (!parsedPhoneNumber) {
            setMobileError("Please enter a valid phone number.");
            return false;
        }
        const isValid = isValidPhoneNumber(phoneNumber);
        const countryCode = parsedPhoneNumber.country;

        if (isValid) {
            const phoneNumberLength = parsedPhoneNumber.nationalNumber.length;
            if (PhoneValidLenght[countryCode] && phoneNumberLength !== PhoneValidLenght[countryCode]) {
                setMobileError(`Please enter a valid ${countryCode} phone number with ${PhoneValidLenght[countryCode]} digits.`);
                return false;
            }

            setMobileError("");
            return true;
        } else {
            setMobileError(`Please enter a valid phone number.`);
            return false;
        }
    };

    const handleNationlityChange = (e) => {
        setSelectNationlity(e.target.value);
    };

    const validateForm = () => {
        if (
            firstName.trim() === '' ||
            lastName.trim() === '' ||
            organizationEmail.trim() === '' ||
            password.trim() === '' ||
            confirmPassword.trim() === '' ||
            !value
        ) {
            setError('Please enter all fields');
            return false;
        }
        setError('');
        return true;
    };
    const ValidatePassword = (password) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{11,}$/;
        setIsValidPassword(regex.test(password))
    }

    const handlePasswordChange = (event) => {
        const { value } = event.target;
        setPassword(value);
        ValidatePassword(value);
    }
    // <---------- Checked the Terms & Condition's ------------>
    const handleCheckboxChange = () => {
        setIsTACChecked(!isTACChecked);
    };


    const funCountryId = (e) => {
        setDefaultCountryCode(e.iso2)
        setCountryid(e.id);
    }

    const funStateId = (e) => {
        setstateid(e)
    }

    const funCityId = (e) => {
        setcityid(e)
    }

    // List of disallowed email domains
    const disallowedDomains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "aol.com"];

    // Function to validate if the email is a company email
    const isValidCompanyEmail = (email) => {
        // Basic regex for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check if email format is valid
        if (!emailRegex.test(email)) return false;

        // Split email into parts
        const emailParts = email.split('@');

        // Ensure the domain part is present
        if (emailParts.length !== 2) return false;

        // Get the domain part and convert to lowercase
        const domain = emailParts[1].toLowerCase();

        // Check if the domain is in the disallowed list
        return !disallowedDomains.includes(domain);
    };




    // <---------- Send Otp For  Recruiter SignUp ----------------------->
    const SendOtpRecruiterSignUp = async () => {
        setIsLoading(true)
        try {
            if (!validateForm()) {
                setIsLoading(false)
                return;
            }
            else if (password !== confirmPassword) {
                setIsLoading(false)
                setTimeout(() => {
                    toast.error("Password Do Not Match !!!");
                }, 1000)
                return;
            }

            if (!firstName || firstNameError || !lastName || lastNameError) {
                toast.error("Name should contain only alphabetical letters");
                setIsLoading(false)
                return;
            }

            if (!isValidEmail) {
                toast.error("Please enter a valid email id");
                setIsLoading(false);
                return;
            }

            if (!validatePhoneNumber(value)) {
                toast.error("Please enter a valid phone number.");
                setIsLoading(false);
                return;
            }
            if (!phoneNumber) {
                toast.error("Please enter a  phone number.");
                setIsLoading(false);
                return;
            }

            if (!isTACChecked) {
                toast.error("Please accept the Terms & Conditions and Privacy Policy.");
                setIsLoading(false)
                return;
            }
            // if (!DOB) {
            //     toast.error("Please select your date of brith");
            //     setIsLoading(false)
            //     return;
            // }
            // if (!selectNationlity) {
            //     toast.error("Please select your nationlity");
            //     setIsLoading(false)
            //     return;
            // }

            // Validate the company email domain
            // if (!isValidCompanyEmail(companyName)) {
            //     toast.error("Please use your company email. Personal email domains like Gmail, Yahoo, Outlook are not allowed.");
            //     setIsLoading(false);
            //     return;
            // }

            if (!companyName) {
                toast.error("Please enter the company name");
                setIsLoading(false);
                return;
            }

            if (country && state) {
                console.log('Form submitted:', { country, state });
            }
            else {
                setIsLoading(false)
                setTimeout(() => {
                    toast.error('Please select country, state');
                }, 1000)
                return;
            }
            if (password.length < 10) {
                setIsLoading(false)
                setTimeout(() => {
                    toast.error("Password must be have 10 digits !!!")
                }, 1000)
                return;
            }
            const userData = {
                type: "signup",
                email: organizationEmail
            };

            const RecruiterData = {
                role_id: 4,
                fname: firstName,
                lname: lastName,
                email: organizationEmail,
                password,
                countryCode: countryCode,
                companyName,
                mobile: phoneNumber,
                dob: DOB,
                citizen: selectNationlity,
                city: city,
                state: state,
                country: country.name,
                tcCheck: 1,
                time_zone: timeZoneAbbr

            }

            const response = await SendOtp(userData)
            if (response.data.statusCode == "200") {
                toast.success("Otp send on your email, please check !!!");
                localStorage.setItem("Recruiter_Register_Email", response.data.data.email)
                localStorage.setItem("Recruiter_Register_Data", JSON.stringify(RecruiterData));
                setTimeout(() => {
                    navigate("/RecruiterSignUpOtpVerify")
                    setIsLoading(false)
                }, 2000)
            }
            else if (response.data.statusCode == "400") {
                setIsLoading(false);
                setTimeout(() => {
                    setIsLoading(false);
                    toast.warn(response?.data?.msg);
                    window.location.reload();
                }, 1000);
            }

        } catch (error) {
            console.log("Error:", error);
            setIsLoading(true)
        }
    }
    const getRecruiter = localStorage.getItem("HandleRecruiter")
    const getMentorship = localStorage.getItem("HandleMentorship")

    useEffect(() => {
        document.title = '::Signup::';
    }, []);

    const RemoveLocalStorage = () => {
        localStorage.removeItem("HandleMentorship");
        localStorage.removeItem("HandleRecruiter");
    }

    const StudentSignUpPage = () => {
        navigate("/Student_SignUp")
        localStorage.setItem("ActiveTabs", "student")
    }

    const RecuriterSignUpPage = () => {
        navigate("/Recruiter_SignUp")
        localStorage.setItem("ActiveTabs", "Recruiter")
    }

    const MentorSignUpPage = () => {
        navigate("/Mentor_SignUp")
        localStorage.setItem("ActiveTabs", "Mentor")
    }

    // <---------- Get Privacy & ploicy ------------->
    const GetPrivacyPolicy = async () => {
        try {
            const response = await PrivacyPolicy();
            setPrivacyPolicyList(response?.data?.data)
        } catch (error) {
            console.log("error", error)
        }
    }

    // <---------- Get Privacy & ploicy ------------->
    const GetTermsCondtion = async () => {
        try {
            const response = await TermsCondtion();
            setTermsConditionList(response?.data?.data)
        } catch (error) {
            console.log("error", error)
        }
    }

    useEffect(() => {
        GetPrivacyPolicy();
        GetTermsCondtion();
    }, [])
    return (
        <div>
            <div className="login-signup-bg">
                <Header />
                {
                    isLoading ? (
                        <>
                            <div className="chat-window text-center">
                                <div style={{
                                    position: "absolute",
                                    top: 0,
                                    bottom: 0,
                                    margin: "auto",
                                }} className="spinner-border" role="status">
                                    <span className="sr-only"></span>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="user-area p-2 p-md-4 p-lg-5 pt-lg-3">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-6 p-0 d-none d-md-none d-lg-block">
                                            <div className="user_login">
                                                <img src={CommonImageTransport.loginbg} className="imgk-fluid w-100" alt="login-banner" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 d-flex p-0">
                                            <div className="user-all-form userlogin position-relative">
                                                <div className="login_bottom">
                                                    <img src={CommonImageTransport.loginBottom} alt="" />
                                                </div>
                                                <div className="contact-form m-0 py-0">

                                                    <h3 className="user-title"> Sign up for an account</h3>

                                                    <ul className="nav tabs_signup justify-content-start gap-2">

                                                        <li className="nav-item">
                                                            <a className={`${ActiveTabs == "student" ? "nav-link active" : "nav-link"}`}
                                                                aria-current="page" onClick={() => {
                                                                    RemoveLocalStorage();
                                                                    StudentSignUpPage()
                                                                }}>Student</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`${ActiveTabs == "Recruiter" ? "nav-link active" : "nav-link"}`} onClick={() => {
                                                                RecuriterSignUpPage()
                                                            }}
                                                            >Recruiter</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className={`${ActiveTabs == "Mentor" ? "nav-link active" : "nav-link"}`} onClick={() => {
                                                                MentorSignUpPage()
                                                            }}
                                                            >Mentor</a>
                                                        </li>
                                                    </ul>
                                                    <form id="contactForms" className="mt-2">
                                                        <div className="row">
                                                            <ToastContainer style={{ marginTop: "100px" }} />
                                                            <div className='col-md-4'>
                                                                <div className="form-floating form-group">
                                                                    <h6>Country</h6>
                                                                    <CountrySelect
                                                                        defaultValue={country}
                                                                        value={country}
                                                                        name="country"
                                                                        onChange={(selectedCountry) => {
                                                                            setCountry(selectedCountry);
                                                                            funCountryId(selectedCountry)
                                                                        }}
                                                                        placeHolder="Select Country"
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className='col-md-4'>
                                                                <h6>State</h6>
                                                                <StateSelect
                                                                    country={country}
                                                                    value={state}
                                                                    countryid={countryid}
                                                                    onChange={(selectedState) => {
                                                                        funStateId(selectedState.id)
                                                                        setState(selectedState.name);
                                                                    }}
                                                                    placeHolder="Select State"
                                                                />
                                                            </div>

                                                            <div className='col-md-4'>
                                                                <h6>City</h6>
                                                                <CitySelect
                                                                    country={country}
                                                                    state={state}
                                                                    value={city}
                                                                    countryid={countryid}
                                                                    stateid={stateid}
                                                                    cityid={cityid}
                                                                    onChange={(selectedCity) => {
                                                                        funCityId(selectedCity.id)
                                                                        setCity(selectedCity.name);
                                                                    }}
                                                                    placeHolder="Select City"
                                                                />
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="form-floating form-group">
                                                                    <input type="text" className="form-control" id="floatingInput"
                                                                        placeholder="" name="firstName"
                                                                        value={firstName}
                                                                        onChange={(event) => handleInputChange(event, setFirstName, setFirstNameError)} />
                                                                    <label htmlFor="floatingInput">First Name</label>
                                                                    {firstNameError && <p style={{ color: 'red', fontSize: '14px' }}>{firstNameError}</p>}
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6">
                                                                <div className="form-floating form-group">
                                                                    <input type="text" className="form-control" id="floatingInput"
                                                                        placeholder="" name="lastName"
                                                                        value={lastName}
                                                                        onChange={(event) => handleInputChange(event, setLastName, setLastNameError)} />
                                                                    <label htmlFor="floatingInput">Last Name</label>
                                                                    {lastNameError && <p style={{ color: 'red', fontSize: '14px' }}>{lastNameError}</p>}
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-12">
                                                                <div className="form-floating form-group">
                                                                    <input type="email" name='companyName' value={companyName} className="form-control" id="floatingInput"
                                                                        placeholder=" " onChange={(e) => setCompanyName(e.target.value)} />
                                                                    <label htmlFor="floatingInput">Company Name</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-12">
                                                                <div className="form-floating form-group">
                                                                    <input type="email" onChange={handleChange} className="form-control" id="floatingInput" placeholder="" />
                                                                    <label htmlFor="floatingInput">Organization Email</label>
                                                                    {!emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 position-relative">

                                                                <div className="form-floating form-group">
                                                                    <PhoneInput
                                                                        className="phoneinput form-control"
                                                                        international
                                                                        countryCallingCodeEditable={false}
                                                                        defaultCountry={defaultCountryCode}
                                                                        placeholder="Enter phone number"
                                                                        value={value}
                                                                        onChange={setValue}
                                                                    />
                                                                    {mobileError && (
                                                                        <p style={{ color: "red", fontSize: "14px" }}>
                                                                            {mobileError}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-lg-6 position-relative">
                                                                <span className="form-floating form-group">
                                                                    <input
                                                                        type={showPassword ? "text" : "password"}
                                                                        className="form-control"
                                                                        id="floatingPassword"
                                                                        placeholder="xxxxxxxx"
                                                                        value={password}
                                                                        onChange={(e) => handlePasswordChange(e)}
                                                                    />
                                                                    <label htmlFor="floatingPassword">Password</label>

                                                                </span>
                                                                <span onClick={() => setShowPassword(!showPassword)} className="password-toggle eye"
                                                                >
                                                                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                                                                </span>
                                                            </div>
                                                            <div className="col-12 col-lg-6 position-relative">
                                                                <div className="form-floating form-group">
                                                                    <input type={showConfirmPassword ? "text" : "password"} className="form-control" id="floatingPassword"
                                                                        placeholder="xxxxxxxx"
                                                                        value={confirmPassword}
                                                                        onChange={(e) => setConfirmPassword(e.target.value)} />
                                                                    <label htmlFor="floatingPassword">Confirm password</label>
                                                                </div>
                                                                <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="password-toggle eye"
                                                                >
                                                                    {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                                                                </span>
                                                            </div>

                                                            {!isValidPassword && <p style={{ color: 'red' }}>Password must be at least 11 characters long, contain at least
                                                                one lowercase letter, one uppercase letter, one digit, and one special character (@$!%*?&).</p>}
                                                            {/* <div className="col-lg-6 col-12">
                                                                <div className="form-floating form-group">
                                                                   
                                                                    <input
                                                                        type="date"   className="form-control"
                                                                        value={
                                                                            DOB
                                                                                ? new Date(DOB)
                                                                                    .toISOString()
                                                                                    .split("T")[0]
                                                                                : ""
                                                                        }
                                                                        onChange={(e) =>
                                                                            setDOB(e.target.value)
                                                                        }
                                                                        name="DOB"
                                                                        placeholder="dob"
                                                                        max={maxDateString} 
                                                                        required 
                                                                    />
                                                                     <label className="floatingInput">
                                                                        DOB
                                                                    </label>
                                                                    {DOB && new Date(DOB) > maxDate && (
                                                                        <p style={{ color: "red" }}>
                                                                            You must be at least 18 years old.
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-12">
                                                                <div className="form-group">
                                                                    <select id="country-select" value={selectNationlity} onChange={handleNationlityChange} className="form-control">
                                                                        <option value="">--Select a Nationality--</option>
                                                                        {countries?.map((country, index) => (
                                                                            <option key={index} value={country}>
                                                                                {country}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                            <div className="col-lg-12 form-condition">
                                                                <div className="agree-label">
                                                                    <input type="checkbox" id="chb1" onChange={handleCheckboxChange}
                                                                        checked={isTACChecked} />
                                                                    <label htmlFor="chb1" className="small">
                                                                        All your information is collected, stored and processed as per our data
                                                                        processing guidelines. By signing up on FreshGrad, you agree to our <Link to="#" onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setShowPrivacyPolicy(true);
                                                                        }}>Privacy
                                                                            Policy</Link> <Link to="#">and</Link> <Link to="#" onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setShowTermsCondition(true);
                                                                            }}>Terms of Use</Link>
                                                                    </label>
                                                                    {/* {!isChecked && <p style={{ color: 'red' }}>Please accept the terms and conditions before signing up.</p>} */}
                                                                </div>
                                                            </div>
                                                            {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
                                                            <div className="col-lg-12 col-md-12">
                                                                <button type='button' className="default-btn w-100 rounded"
                                                                    onClick={SendOtpRecruiterSignUp}>
                                                                    Sign Up
                                                                </button>
                                                                <h6 className="mt-4 text-center fw-normal text-muted">Already have an account? <Link
                                                                    className="fw-bold" to="/Signin">Login</Link></h6>
                                                            </div>
                                                        </div>
                                                    </form>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>

                    )
                }

                {/* <--------- T & C Modal section's ------------> */}
                <Modal
                    size="lg"
                    show={ShowTermsCondition}
                    onHide={() => setShowTermsCondition(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Terms & Conditions</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="row pt-1">
                                <div className="col-lg-12">
                                    <div className="single-content">
                                        <h3>{TermsConditionList?.title}</h3>
                                        <ul>
                                            <li>
                                            <p>{ReactHtmlParser(TermsConditionList?.desciption)}</p>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* <--------- Privacy & Policy section's ------------> */}
                <Modal
                    size="lg"
                    show={showPrivacyPolicy}
                    onHide={() => setShowPrivacyPolicy(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Privacy & Policy</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="row pt-1">
                                <div className="col-lg-12">
                                    <div className="single-content">
                                        <h3>{PrivacyPolicyList?.title}</h3>
                                        <ul>
                                            <li>
                                            <p>{ReactHtmlParser(PrivacyPolicyList?.desciption)}</p>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        </div>
    )
}

export default Recruiter
